import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { event } from '../../../elements/funciones/estructuras';

@Injectable({
  providedIn: 'root'
})
export class MatrizEventosService {

  private apiUrl = environment.apiOperativoDev;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private cookies: CookieService,
    private https: HttpClient, 
  ) {  }

  getCatalogos(idInstitucion: string, catalog: string){
    const apiUrl = `${this.apiUrl}catalogues/${idInstitucion}/${catalog}`
    return this.https.get(`${apiUrl}`, {headers: this.headers})
  }
  getEventos(){
    const apiURL = this.apiUrl+'events';
    return this.https.get(`${apiURL}`,{ headers: this.headers});
  }
  postEventos(rep){
    const r: event = {
      area: rep.area,
      branch_office: rep.branch_office,
      category: rep.category,
      concept: rep.concept,
      event: rep.event,
      event_date: rep.event_date,
      detail: rep.detail,
      action_taken: rep.action_taken,
      source: rep.source,
      derived_risk: rep.derived_risk,
      loss: rep.loss,
      loss_amount: rep.loss_amount,
      transferred_loss: rep.transferred_loss,
      net_loss: rep.net_loss,
      impact: rep.impact,
      probability: rep.probability,
      control: rep.control,
      x: rep.x,
      y: rep.y,
      implicit_risk: rep.implicit_risk,
      implicit_risk_level: rep.implicit_risk_level,
      control_2: rep.control_2,
      to_control: rep.to_control,
      exposure_level: rep.exposure_level,
      recommendation: rep.recommendation,
      work_plan: rep.work_plan,
      deadline: rep.deadline,
      plan_status: rep.plan_status,
      institution_id: rep.institution_id,
    }

    const body = JSON.stringify(r);
    const apiURL = this.apiUrl+'events';
    return this.https.post(`${apiURL}`, body, {headers: this.headers})
  }
  patchEventos(rep){
    const r: event = {
      area: rep.area,
      branch_office: rep.branch_office,
      category: rep.category,
      concept: rep.concept,
      event: rep.event,
      event_date: rep.event_date,
      detail: rep.detail,
      action_taken: rep.action_taken,
      source: rep.source,
      derived_risk: rep.derived_risk,
      loss: rep.loss,
      loss_amount: rep.loss_amount,
      transferred_loss: rep.transferred_loss,
      net_loss: rep.net_loss,
      impact: rep.impact,
      probability: rep.probability,
      control: rep.control,
      x: rep.x,
      y: rep.y,
      implicit_risk: rep.implicit_risk,
      implicit_risk_level: rep.implicit_risk_level,
      control_2: rep.control_2,
      to_control: rep.to_control,
      exposure_level: rep.exposure_level,
      recommendation: rep.recommendation,
      work_plan: rep.work_plan,
      deadline: rep.deadline,
      plan_status: rep.plan_status,
      institution_id: rep.institution_id,
    }

    const body = JSON.stringify(r);
    const apiURL = this.apiUrl+'events/'+rep.id;
    return this.https.patch(`${apiURL}`, body, {headers: this.headers})
  }
  deleteEventos(rep){
    const apiURL = this.apiUrl+'events/'+rep.id;
    return this.https.delete(`${apiURL}`,{headers: this.headers});
  }
}
